import React from 'react';
import { REGISTER_URL } from './data';

const TONES = {
  lime: 'bg-[#D7FF38] text-[#111]',
  ink: 'bg-[#111] text-[#F5F3EB]',
  blue: 'bg-[#365CFF] text-white',
  orange: 'bg-[#FF6338] text-[#111]',
};

export const RegisterButton = ({ label = 'REGISTER NOW →', tone = 'lime', size = 'md', testId, className = '' }) => (
  <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`cv-btn inline-flex items-center justify-center font-extrabold uppercase tracking-wider border-2 border-[#111] shadow-[4px_4px_0_#111] ${TONES[tone]} ${size === 'lg' ? 'px-7 py-4 text-sm sm:text-base' : size === 'sm' ? 'px-3.5 py-2 text-xs' : 'px-5 py-3 text-sm'} ${className}`}>
    {label}
    <span className="sr-only"> (opens the EvalentX registration page in a new tab)</span>
  </a>
);
